var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('b-skeleton',{attrs:{"width":"60px","height":"42px"}}),_c('b-skeleton',{staticClass:"ml-1 mt-3",attrs:{"width":"120px","height":"17px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }